import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Table,
  Tbody,
  Text,
  Tr,
  Td,
  Thead,
  Th,
  Input,
  Button,
  Select,
  useToast,
  Stack,
  Badge,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
} from "@chakra-ui/react";
import axios from "axios";
import {
  FaEllipsisV,
  FaPrint,
  FaSync,
  FaWhatsapp,
  FaPhone,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import EditGuardianModal from "./EditGuardianModal";
import Print_pdf_guardian from "./Print_pdf_guardian";
import { BASE_URL } from "../../Globalapi/Globalapi";

const ParentList = () => {
  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchField, setSearchField] = useState("guardian");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredParents, setFilteredParents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedGuardian, setSelectedGuardian] = useState(null); // State for the selected guardian
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const toast = useToast();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  const itemsPerPage = 50; // Define items per page
  const totalPages = Math.ceil(filteredParents.length / itemsPerPage); // Calculate total pages

  useEffect(() => {
    fetchParents();
  }, []);

  useEffect(() => {
    const lowerCaseTerm = searchTerm.toLowerCase();
    const results = parents.filter((parent) => {
      const fieldValue =
        searchField === "student" ? parent.studentname : parent.name;

      return fieldValue?.toLowerCase().includes(lowerCaseTerm);
    });

    setFilteredParents(results);
  }, [searchTerm, searchField, parents]);

  const fetchParents = async () => {
    setLoading(true);
    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/guardian/list_all_guardian.php?school_id=${school_id}`
      );
      console.log("guard", response);

      if (response.data.success === true && Array.isArray(response.data.data)) {
        setParents(response.data.data);

        setFilteredParents(response.data.data);
        setIsDataLoaded(true); // Mark data as loaded
      } else {
        toast({
          title: "Error",
          description: "Unexpected data format.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Could not fetch data. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEditGuardian = (guardian) => {
    console.log("Editing guardian:", guardian);
    setSelectedGuardian(guardian); // Store the selected guardian data
    setIsModalOpen(true); // Open the modal
  };

  const handleWhatsAppClick = (contactNo) => {
    window.open(`https://wa.me/${contactNo}`, "_blank");
  };

  const handleCallClick = (contactNo) => {
    window.open(`tel:${contactNo}`);
  };

  // Get current items for pagination
  const paginatedParents = filteredParents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <Box bg="white" borderRadius="md" shadow="md">
      <div className="teacher-list-container">
        {/* Header */}
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Guardians List</h1>
          <div className="action-buttons">
            {/* <Button
              onClick={() => window.location.reload()}
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
            >
              <FaSync color="#515B73" />
            </Button> */}
            <Button
              className="export-button"
              display={{ base: "none", md: "flex" }}
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
              onClick={handlePrint} // Attach the print handler here
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Students</span> / <span>Guardian List</span>
        </div>
        <Box mt={8}>
          {/* Rows Per Page, Search Field, and Dropdown */}
          <Box mt={4}>
            <Flex
              className="sb"
              direction={{ base: "column", md: "row" }}
              align="center"
              justify="space-between"
              bg="white"
              p={3}
              borderRadius="md"
              // shadow="md"
              gap={{ base: 4, md: 0 }}
            >
              <Flex
                align="center"
                gap={4}
                width={{ base: "100%", md: "auto" }}
                justify={{ base: "flex-start", md: "flex-start" }}
                whiteSpace="nowrap" // Prevents breaking to a new line
              >
                <Text>Rows Per Page:</Text>
                <Select
                  width={{ base: "auto", md: "100px" }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  borderColor="#E9EDF4"
                >
                  <option value={50}>50</option>
                  <option value={75}>75</option>
                  <option value={100}>100</option>
                </Select>
              </Flex>

              <Flex
                align="center"
                gap={4}
                mt={{ base: 4, md: 0 }}
                width={{ base: "100%", md: "auto" }}
                justify={{ base: "space-between", md: "flex-start" }}
                flexDirection={{ base: "column", md: "row" }}
              >
                <Select
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                  width={{ base: "100%", md: "150px" }}
                  borderColor="#E9EDF4"
                >
                  <option value="guardian">Guardian Name</option>
                  <option value="student">Student Name</option>
                </Select>

                <Input
                  placeholder={`Search by ${
                    searchField === "guardian"
                      ? "Guardian Name"
                      : "Student Name"
                  }`}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  width={{ base: "100%", md: "250px" }}
                  borderColor="#E9EDF4"
                />
              </Flex>
            </Flex>
          </Box>

          <Box overflowX="auto">
            {/* Table and Pagination */}
            <Table
              // variant="striped"
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                "th, td": {
                  textAlign: "center",
                },
              }}
            >
              <Thead>
                <Tr textAlign="center">
                  <Th>Guardian Name</Th>
                  <Th>Student Name</Th>
                  <Th>Class</Th>
                  <Th>Status</Th>
                  <Th style={{ textAlign: "center" }}>Action</Th>{" "}
                  {/* New Contact Column */}
                </Tr>
              </Thead>
              <Tbody>
                {paginatedParents.length > 0 ? (
                  paginatedParents.map((parent) => (
                    <Tr
                      key={`${parent.user_id}-${
                        parent.student_id || parent.guardian_id
                      }`}
                    >
                      <Td py="12px" px="20px">
                        <Link
                          to={`/guardian/view/${parent.user_id}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {parent.name}
                        </Link>
                      </Td>
                      <Td py="12px" px="20px">
                        {parent.studentname}
                      </Td>
                      <Td py="12px" px="20px">
                        {parent.class}
                      </Td>
                      <Td py="12px" px="20px">
                        <Badge
                          colorScheme={
                            parent.status === "Active" ? "green" : "green"
                          }
                          borderRadius="full"
                          px={4}
                          py={1}
                          fontSize="11px"
                        >
                          {parent.status === "Active" ? "Active" : "Active"}
                        </Badge>
                      </Td>
                      <Td py="12px" px="20px">
                        <Button
                          colorScheme="teal"
                          variant="ghost"
                          onClick={() => handleWhatsAppClick(parent.contact_no)}
                          leftIcon={<FaWhatsapp />}
                        ></Button>
                        <Button
                          colorScheme="blue"
                          variant="ghost"
                          onClick={() => handleCallClick(parent.contact_no)}
                          leftIcon={<FaPhone />}
                        ></Button>
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            icon={<FaEllipsisV />}
                            variant="ghost"
                          />
                          <MenuList>
                            <MenuItem
                              onClick={() => handleEditGuardian(parent)}
                            >
                              Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                console.log(`Delete ${parent.user_id}`)
                              }
                            >
                              Delete
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="6" textAlign="center">
                      No results found
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>
          {/* Pagination */}
          <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>
        {/* Edit Guardian Modal */}
        <EditGuardianModal
          guardian={selectedGuardian} // Pass the selected guardian object
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onGuardianUpdated={fetchParents} // Refresh the list after editing
          isCentered
        />
        <div style={{ display: "none" }}>
          <Print_pdf_guardian ref={printComponentRef} parents={parents} />
        </div>
      </div>
    </Box>
  );
};

export default ParentList;
